export default "__VITE_ASSET__Cd$5jrGn__"